import React from 'react';
import { motion } from 'framer-motion';
interface PageHeaderProps {
  number: string;
  title: string;
  blurb: string;
}
const ease = [0.23, 1, 0.32, 1] as const;
export function PageHeader({
  number,
  title,
  blurb
}: PageHeaderProps) {
  return <section className="border-b border-white/10 bg-navy text-paper" data-id="element-82" data-mp="3rducet93wjb5">
      <div className="mx-auto max-w-shell px-6 py-16 lg:px-10 lg:py-20" data-id="element-83" data-mp="3mgkgqvv4jbev">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="grid gap-6 lg:grid-cols-12 lg:items-end lg:gap-16" data-id="element-84" data-mp="2ypezqddg6d2z">
          <div className="lg:col-span-8" data-id="element-85" data-mp="38gjebbz7nvxa">
            <p className="text-[11px] uppercase tracking-overline text-gold-soft" data-id="element-86" data-mp="33p1dqp13nxcu">
              Section {number}
            </p>
            <h1 className="mt-5 font-display text-4xl font-light leading-[1.1] lg:text-5xl" data-id="element-87" data-mp="2fynjcrv1lmf3">
              {title}
            </h1>
          </div>
          <p className="max-w-md border-l border-white/15 pl-6 text-[14px] leading-relaxed text-white/60 lg:col-span-4" data-id="element-88" data-mp="2b03y6to9wens">
            {blurb}
          </p>
        </motion.div>
      </div>
    </section>;
}